export default __webpack_public_path__ + "static/video-3-poster-91155d1fcec1cbbc02a782da8333a249.png";